import React from 'react';

import Layout from './components/Layout'
import Profile from './components/Profile'

function app() {
  return (
    <Layout>
      <Profile />
    </Layout>
  );
}

export default app;
